
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import BottomNavigation from "./components/BottomNavigation";

import LanguageSelectPage from "./pages/LanguageSelectPage";
import EnglishHomePage from "./pages/EnglishHomePage";
import SpanishHomePage from "./pages/SpanishHomePage";
import RussianHomePage from "./pages/RussianHomePage";
import TagalogHomePage from "./pages/TagalogHomePage";

import PrayerDisplayPage from "./pages/PrayerDisplayPage";

import MorePage from "./pages/MorePage";
import SpanishMorePage from "./pages/SpanishMorePage";
import RussianMorePage from "./pages/RussianMorePage";
import TagalogMorePage from "./pages/TagalogMorePage";

import AboutPage from "./pages/AboutPage";
import InstallPage from "./pages/InstallPage";
import SupportPage from "./pages/SupportPage";

import "./styles/glassbuttons.css";
import "./styles/animations.css";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app-content">
        <Routes>
          <Route path="/" element={<LanguageSelectPage />} />

          <Route path="/en" element={<EnglishHomePage />} />
          <Route path="/es" element={<SpanishHomePage />} />
          <Route path="/ru" element={<RussianHomePage />} />
          <Route path="/tl" element={<TagalogHomePage />} />

          <Route path="/more" element={<MorePage />} />
          <Route path="/es/more" element={<SpanishMorePage />} />
          <Route path="/ru/more" element={<RussianMorePage />} />
          <Route path="/tl/more" element={<TagalogMorePage />} />

          <Route
            path="/:lang/prayer/:category"
            element={<PrayerDisplayPage />}
          />

          <Route path="/about" element={<AboutPage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route path="/support" element={<SupportPage />} />

          <Route path="*" element={<Navigate to="/en" replace />} />
        </Routes>
      </div>

      <BottomNavigation />
    </Router>
  );
}

export default App;
